import * as React from "react";

import CardList from "~/components/CustomerSupport/CardList";
import GiftCardBalanceChecker from "~/components/GiftCard/GiftCardBalanceChecker";
import { GiftCardFAQs } from "~/components/GiftCard/GiftCardFAQs";
import client from "~/graphql/client";
import {
  GIFT_CARD_BY_CODE_QUERY,
  IGiftCardByCode
} from "~/graphql/queries/giftCard/giftCardByCode";

export interface IState {
  errorMessage: string;
  giftCardData: IGiftCardByCode | undefined;
  giftCardNotFound: string;
  giftCardNumber: string;
  isRecaptchaVerified: boolean;
  recaptchaToken: string;
  recaptchaWarning: boolean;
}

class GiftCardContainer extends React.Component<{}, IState> {
  public readonly state = {
    errorMessage: "",
    giftCardData: undefined,
    giftCardNotFound: "",
    giftCardNumber: "",
    isRecaptchaVerified: false,
    recaptchaToken: "",
    recaptchaWarning: false
  };

  public render() {
    const {
      giftCardNumber,
      giftCardNotFound,
      recaptchaWarning,
      giftCardData,
      errorMessage
    } = this.state;

    return (
      <CardList>
        <GiftCardBalanceChecker
          giftCardNumber={giftCardNumber}
          giftCardNotFound={giftCardNotFound}
          onChange={this.handleInputChange}
          onRecaptchaChange={this.handleRecaptchaChange}
          onSubmit={this.handleSubmit}
          showWarning={recaptchaWarning}
          giftCardData={giftCardData}
          errorMessage={errorMessage}
        />

        <GiftCardFAQs />
      </CardList>
    );
  }

  private handleRecaptchaChange = (value: string) => {
    this.setState(prevState => ({
      ...prevState,
      isRecaptchaVerified: true,
      recaptchaToken: value,
      recaptchaWarning: false
    }));
  };

  private handleInputChange = (state: Partial<IState>) =>
    this.setState(prevState => ({ ...prevState, ...state }));

  private handleSubmit = async () => {
    if (!this.state.isRecaptchaVerified) {
      this.setState(prevState => ({
        ...prevState,
        recaptchaWarning: true
      }));

      return;
    }

    this.setState(prevState => ({ ...prevState, errorMessage: "" }));

    try {
      try {
        (window as any).grecaptcha.reset();
      } catch (e) {
        // Ignore errors
      }

      const result = await client.query<IGiftCardByCode>({
        query: GIFT_CARD_BY_CODE_QUERY,
        variables: {
          code: this.state.giftCardNumber,
          gRecaptchaToken: this.state.recaptchaToken
        }
      });

      if (result.data) {
        this.setState(prevState => ({
          ...prevState,
          giftCardData: result.data
        }));
      }
    } catch (error) {
      this.setState({ errorMessage: error.message });
    }

    this.setState(prevState => ({
      ...prevState,
      giftCardNotFound: this.state.giftCardNumber,
      giftCardNumber: ""
    }));
  };
}

export default GiftCardContainer;



// WEBPACK FOOTER //
// ./src/containers/GiftCard/GiftCardContainer.tsx